module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1259.bd3ce31b.png";